import { buildQuery } from '@calendly/http-tools'

export const buildChromeWebstoreURL = ({ utmSource, utmMedium, utmCampaign, utmContent, utmTerm }) => (
  `https://chromewebstore.google.com/detail/calendly-meeting-scheduli/cbhilkcodigmigfbnphipnnmamjfkipp${buildQuery({
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    utm_content: utmContent,
    utm_term: utmTerm,
  }, { addQueryPrefix: true })}`
)
